import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation, useParams, useSearchParams } from 'react-router-dom';
import { AuthContext } from '../../App';
import PageContainer from '../layouts/PageContainer';
import LearningPathDesignerScreen from './LearningPathDesignerScreen';

const SuperAdminLearningPathDesignerScreen: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathId } = useParams<{ pathId: string }>();
  const [searchParams] = useSearchParams();
  const cloneFromId = searchParams.get('cloneFrom');
  const { activeRole } = useContext(AuthContext);
  // Initialize mode directly based on pathId to prevent flashing
  const [mode, setMode] = useState<'create' | 'manage'>(pathId ? 'manage' : 'create');
  // Add loading state to prevent flashing of content
  const [isReady, setIsReady] = useState(false);
  
  // Redirect if not super admin or school admin
  useEffect(() => {
    if (activeRole !== 'SuperAdmin' && activeRole !== 'SchoolAdmin') {
      navigate('/', { replace: true });
    }
  }, [activeRole, navigate]);
  
  useEffect(() => {
    // Determine if we're editing an existing path or creating a new one
    if (pathId) {
      setMode('manage');
    } else {
      setMode('create');
    }
    // Mark component as ready after mode is set
    setIsReady(true);
  }, [pathId]);
  
  const handleCancel = () => {
    // Use replace: true to prevent flashing during navigation
    navigate('/superadmin/learning-paths', { replace: true });
  };
  
  return (
    <PageContainer title={mode === 'create' ? 'Create District Learning Path' : 'Edit District Learning Path'} userRole="SuperAdmin">
      {/* Only render content when component is ready to prevent flashing */}
      {isReady && (
        <div className="superadmin-learning-path-designer">
          <div className="mb-4 flex justify-between items-center">
            <h1 className="text-2xl font-bold text-gray-800">
              {mode === 'create' ? 'Create District Learning Path' : 'Edit District Learning Path'}
            </h1>
            <button
              onClick={handleCancel}
              className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
            >
              Back to Learning Paths
            </button>
          </div>
          
          {/* Reuse the existing LearningPathDesignerScreen component */}
          <LearningPathDesignerScreen mode={mode} />
        </div>
      )}
    </PageContainer>
  );
};

export default SuperAdminLearningPathDesignerScreen;
